import { CHCPDLViewerAlert } from './pdl-viewer-alert.component.js';
export { CHCPDLViewerAlert };

customElements.define('chcapp-pdl-viewer-alert', CHCPDLViewerAlert);

declare global {
  interface HTMLElementTagNameMap {
    'chcapp-pdl-viewer-alert': CHCPDLViewerAlert;
  }
}
